<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="goodsId" :label="$t('选择商品')">
        <a-button type="primary" @click="openGoodsSelect">{{ $t('选择商品') }}</a-button>
      </a-form-model-item>
      <a-form-model-item prop="goodsName" :label="$t('商品名称')">
        <a-input v-model="form.goodsName" :maxLength="100" :disabled="true" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="avatar" :label="$t('头像')">
        <oss-upload-single :height="100" :width="100" v-model="form.avatar" prefix="goods" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="userName" :label="$t('昵称')">
        <a-input v-model="form.userName" :maxLength="32" :placeholder="$t('请输入')+$t('昵称')" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="evaluateScore" :label="$t('评价星级')">
        <a-rate v-model="form.evaluateScore" :allow-clear="false" />
      </a-form-model-item>
      <a-form-model-item prop="content" :label="$t('评价内容')">
        <a-input v-model="form.content" type="textarea" :maxLength="500" :placeholder="$t('请输入')+$t('评价内容')" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="imageList" :label="$t('评价图片')">
        <oss-upload-multi :is-array-data="true" :max-count="9" v-model="form.imageList" prefix="goods" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="isAnonymous" :label="$t('是否匿名评价')">
        <a-switch v-model="form.isAnonymous" :checked-children="$t('是')" :un-checked-children="$t('否')" />
      </a-form-model-item>
      <a-form-model-item prop="isShow" :label="$t('是否展示')">
        <a-switch v-model="form.isShow" :checked-children="$t('是')" :un-checked-children="$t('否')" />
      </a-form-model-item>
<!--      <a-form-model-item prop="goodRate" :label="$t('好评率')">
        <a-input-number
          v-model="form.goodRate"
          :min="0"
          :max="100"
          :step="0.1"
          :precision="1"
          style="width: 80%"
          :placeholder="$t('请输入')+$t('好评率')"
        />
        <span style="margin-left: 8px">%</span>
        <div style="color: #999; font-size: 12px; line-height: 20px;">填写后将同步更新该商品详情页展示的好评率，不填则按本次评价星级累计</div>
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <goods-radio-select ref="goodsRadioSelect" @goodsSelect="indexGoodsModalSelect"/>
  </a-drawer>
</template>

<script>
import { addGoodsEvaluate, getGoodsEvaluateCount } from '@/api/goods/goodsEvaluate'
import GoodsRadioSelect from '@/views/goods/goods/select/GoodsRadioSelect.vue'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import OssUploadMulti from '@/components/OssUploadMulti/index.vue'

export default {
  name: 'AddForm',
  components: {
    GoodsRadioSelect,
    OssUploadSingle,
    OssUploadMulti
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      form: {
        goodsId: null,
        goodsName: null,
        avatar: null,
        userName: null,
        content: null,
        imageList: [],
        evaluateScore: 5,
        isAnonymous: false,
        isShow: true,
        goodRate: undefined
      },
      open: false,
      rules: {
        goodsId: [
          { required: true, message: this.$t('请选择') + this.$t('商品'), trigger: 'change' }
        ],
        avatar: [
          { required: true, message: this.$t('头像') + this.$t('不能为空'), trigger: 'change' }
        ],
        userName: [
          { required: true, message: this.$t('昵称') + this.$t('不能为空'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('评价内容') + this.$t('不能为空'), trigger: 'blur' }
        ],
        evaluateScore: [
          { required: true, message: this.$t('评价星级') + this.$t('不能为空'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.cancel()
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        goodsId: null,
        goodsName: null,
        avatar: null,
        userName: null,
        content: null,
        imageList: [],
        evaluateScore: 5,
        isAnonymous: false,
        isShow: true,
        goodRate: undefined
      }
    },
    indexGoodsModalSelect (records) {
      if (!records || !records.length) {
        return
      }
      this.form.goodsId = records[0].id
      this.form.goodsName = records[0].goodsName
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField('goodsId')
        }
      })
      getGoodsEvaluateCount({ goodsId: this.form.goodsId }).then(response => {
        if (response.data && response.data.goodRate != null) {
          this.form.goodRate = Number(response.data.goodRate)
        }
      })
    },
    openGoodsSelect () {
      this.$refs.goodsRadioSelect.openGoods(this.form.goodsId, null, null, [20, 21])
    },
    handleAdd () {
      this.reset()
      this.open = true
      this.formTitle = this.$t('添加')
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        const payload = {
          goodsId: this.form.goodsId,
          avatar: this.form.avatar,
          userName: this.form.userName,
          content: this.form.content,
          imageList: this.form.imageList,
          evaluateScore: this.form.evaluateScore,
          isAnonymous: this.form.isAnonymous,
          isShow: this.form.isShow,
          goodRate: this.form.goodRate
        }
        addGoodsEvaluate(payload).then(response => {
          if (response.success) {
            this.$message.success(this.$t('新增成功'), 3)
            this.open = false
            this.$emit('ok')
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
